<h2 mat-dialog-title>{{ title }}</h2>

<form [formGroup]="visationForm">
  <mat-dialog-content>
    <p>{{ description }}</p>

    <!-- Iterar sobre los campos configurados -->
    <ng-container *ngFor="let field of fields">
      <!-- Campo de observación (textarea) -->
      <mat-form-field *ngIf="field.type === 'textarea'">
        <mat-label>{{ field.label }}</mat-label>
        <textarea matInput [formControlName]="field.name"></textarea>
      </mat-form-field>

      <!-- Campo de fecha (datepicker) -->
      <mat-form-field *ngIf="field.type === 'datepicker'">
        <mat-label>{{ field.label }}</mat-label>
        <input matInput [matDatepicker]="picker" [formControlName]="field.name">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>

      <!-- Campo de archivo (file input) -->
      <div *ngIf="field.type === 'file'">
        <label>{{ field.label }}</label>
        <input type="file" (change)="onFileChange($event)">
        <p *ngIf="field.originalFileName">{{ field.originalFileName }}</p> <!-- Mostrar el nombre del archivo -->
      </div>
    </ng-container>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button class="button button-outlined-primary button-sm mr-2" (click)="onNoClick()">{{ cancelButtonText }}</button>
    <button class="button button-primary button-sm" (click)="onSubmit()" [disabled]="visationForm.invalid">{{ submitButtonText }}</button>
  </mat-dialog-actions>
</form>
